//@ts-ignore
import { GetStaticProps } from "next";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useState } from "react";

import Section3 from "@/sections/build/section-3";
import Layout from "../components/Layouts/Layout";
import Meta from "../components/Layouts/Meta";

const DeployedPage: any = () => {
  const { t } = useTranslation("build");

  const main = () => (
    <>
      <div className={" mx-auto "}>
        <Section3 />
      </div>
    </>
  );

  return (
    <Layout meta={<Meta title={t("Plus100")} description={t("Plus100")} />}>
      {main()}
    </Layout>
  );
};
export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || "en", [
        "build",
        "market-screener",
        "layout",
        "common",
        "test",
        "trade",
        "walk-through",
        "alert-strategy",
        "add-ons-form",
      ])),
    },
    revalidate: 60, // Regenerates the page every 60 seconds (ISR)
  };
};
export default DeployedPage;
